declare var window

import {ControllerBase} from '../../../controllerBase'
const ko = require('knockout')
import global from 'globalMU'
import {Paginator} from '../../../paginator'



const SelecionarCorController = ControllerBase.extend({
    name: "SelecionarCorController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Produto/_SelecionarCor",
            type: "post",
            cache: false
        };

    },

    newModel: function() {

        return {
            CodigoCorFabricante: null,
            DescricaoCor: null,
            Legenda: null,
            cores: [],
            corSelecionada: null
        };
    },

    antesBinding: function() {

        this.appendToModel({ name: "CorTinta", value: null });

        if (this.produto.get("CorTinta")) {
            var cor = ko.mapping.fromJS(this.produto.get("CorTinta"));
            this.model.CorTinta(cor);

            this.addActionButton({
                    text: "Limpar",
                    'class': "icone-excluir separador",
                    click: $.proxy(function() {

                            this.produto.unset("CorTinta");
                            this.produto.set("Configurado", false);
                            this.model.CorTinta(undefined);

                            if (this.limparCorCallback) {
                                this.limparCorCallback();
                            }

                        },
                        this)
                },
                true);

        }

    },

    pesquisar: function(model, e, pagina) {

        var self = this;

        pagina = pagina ? pagina : 1;

        global.ajax({
            url: "/Produto/PesquisarCor",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: {
                    CodigoProduto: this.produto.get("Codigo"),
                    CodigoCorFabricante: this.model.CodigoCorFabricante(),
                    DescricaoCor: this.model.DescricaoCor(),
                    NumeroPagina: pagina,
                    TamanhoPagina: 20
                }
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var m = data.CoresProduto && data.CoresProduto.Entities
                    ? ko.mapping.fromJS(data.CoresProduto.Entities)
                    : null;

                self.model.Legenda(data.Legenda);
                self.model.cores(m ? m() : undefined);
                self.paginador = new Paginator({
                    container: "#paginador-selecionar-cor",
                    data: data.CoresProduto,
                    pageClickCallback: $.proxy(self.paginar, self, model)
                });

            }
        });

    },

    paginar: function(model, e) {
        this.pesquisar(model, null, e.page);
    },

    selecionar: function(model) {

        $.each(this.model.cores(),
            function() {
                this.selecionado(false);
            });

        model.selecionado(true);
        this.model.corSelecionada(model);
    },

    selecionarCor: function() {

        this.produto.set("CorTinta", this.toJS(this.model.corSelecionada()));
        this.produto.set("Configurado", true);

        if (this.corSelecionadaCallback) {
            this.corSelecionadaCallback();
        }

    }

})

window.SelecionarCorController = SelecionarCorController

export {
    SelecionarCorController
}